export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-treehouse-6112aab590b1c13d41d9e18410ef1431.svg";